import { render, staticRenderFns } from "./CommentsRatingCard.vue?vue&type=template&id=6bd35412&scoped=true&"
import script from "./CommentsRatingCard.vue?vue&type=script&lang=js&"
export * from "./CommentsRatingCard.vue?vue&type=script&lang=js&"
import style0 from "./CommentsRatingCard.vue?vue&type=style&index=0&id=6bd35412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd35412",
  null
  
)

export default component.exports